import { createContext, useContext } from 'react';

interface GrammarPageContextParams {
    refreshIntents: () => Promise<void>;
    removeIntentFromView: (id: string) => void;
}

export const GrammarPageContext = createContext<GrammarPageContextParams>({
    refreshIntents: () => Promise.resolve(),
    removeIntentFromView: () => undefined,
});

export const useGrammarPageContext = () => {
    return useContext(GrammarPageContext);
};
